export abstract class SetupHandler {
  private _logMessages: string[] = [];

  protected constructor(private name: string) {}

  abstract handle(): void;

  init() {
    this.handle();

    // eslint-disable-next-line no-console
    console.info(
      `%c[${this.name}]${this._logMessages.length > 0 ? '\n' : ''}%c${this._logMessages.join('\n')}`,
      'font-weight: bold; color: #3498db;',
      'font-weight: normal;'
    );
  }

  addLogMessage(msg: string) {
    this._logMessages.push(msg);
  }
}
